module.exports = __webpack_public_path__ + "img/groups2.081706c6.png";